import Loadable from 'react-loadable';
/*
 *
 *
 * Codesplitting
 *
 *
 *
 *
 */

export const Flipcard = Loadable({
  loader: () => import('../../components/Flip/mobile/'),
  loading() {
    return null;
  }
});

export const Flippanel = Loadable({
  loader: () => import('../../components/Flip/desktop/'),
  loading() {
    return null;
  }
});

export const PreferencesMobile = Loadable({
  loader: () => import('../../components/Preferences/mobile'),
  loading() {
    return null;
  }
});

export const ConfirmMobile = Loadable({
  loader: () => import('../../components/ConfirmMobile'),
  loading() {
    return null;
  }
});

export const PreferencesDesktop = Loadable({
  loader: () => import('../../components/Preferences/desktop'),
  loading() {
    return null;
  }
});

export const DualPedigreePanel = Loadable({
  loader: () => import('../../components/DualPedigree/Panel/'),
  loading() {
    return null;
  }
});

export const DualPedigreeCenterResizePicModal = Loadable({
  loader: () => import('../../components/DualPedigree/Modal'),
  loading() {
    return null;
  }
});

export const DualPedigreeChangeNameModal = Loadable({
  loader: () => import('../../components/DualPedigree/Modal/changeName'),
  loading() {
    return null;
  }
});

export const InviteModal = Loadable({
  loader: () => import('../../components/InviteModal'),
  loading() {
    return null;
  }
});

export const VerticalSlider = Loadable({
  loader: () => import('../../components/Slider'),
  loading() {
    return null;
  }
});

export const Resolve = Loadable({
  loader: () => import('../../components/Resolve'),
  loading() {
    return null;
  }
});

export const NotificationModal = Loadable({
  loader: () => import('../../components/NotificationModal'),
  loading() {
    return null;
  }
});

export const ProductTour = Loadable({
  loader: () => import('../../components/ProductTour'),
  loading() {
    return null;
  }
});

// export const PrintModalDesktop = Loadable({
//   loader: () => import('../../components/PrintTree'),
//   loading() {
//     return null;
//   }
// });

export const PrintModalDesktopWithDualPedigreeOption = Loadable({
  loader: () => import('../../components/PrintTree/indexDual'),
  loading() {
    return null;
  }
});


export const PrintFlipcardMobile = Loadable({
  loader: () => import('../../components/PrintTreeMobile'),
  loading() {
    return null;
  }
});

export const MoveHelp = Loadable({
  loader: () => import('../../components/Move/Help'),
  loading() {
    return null;
  }
});

export const MoveDecisionPanel = Loadable({
  loader: () => import('../../components/Move/DecisionPanel'),
  loading() {
    return null;
  }
});

export const FloaterPanel = Loadable({
  loader: () => import('../../components/Move/FloaterPanel'),
  loading() {
    return null;
  }
});

export const SlideUpImmediateFam = Loadable({
  loader: () => import('../../components/Flip/mobile/SlideUpImmediateFam'),
  loading() {
    return null;
  }
});

export const SlideUpAddSourceCitation = Loadable({
  loader: () => import('../../components/Flip/mobile/SlideUpAddSourceCitation'),
  loading() {
    return null;
  }
});

export const Navigation = Loadable({
  loader: () => import('../../components/Navigation'),
  loading() {
    return null;
  }
});


export const Legend = Loadable({
  loader: () => import('../../components/Legend/desktop'),
  loading() {
    return null;
  }
});
